import {
  LabelChip,
  LabelChipProps,
  mergeSx,
  SxProps,
  Tooltip,
} from '@cast/design-system';

type Props = {
  sx?: SxProps;
  size?: LabelChipProps['size'];
};

export const TestNodeChip = ({ sx, size = 'sm' }: Props) => (
  <Tooltip
    placement="top"
    title="You provisioned this node to test your node configuration. It's unschedulable and incurs cost. Delete it after validation."
  >
    <LabelChip
      size={size}
      testId="test-node-chip"
      sx={mergeSx(
        {
          backgroundColor: 'yellow.50',
          color: 'yellow.900',
          fontWeight: '700',
        },
        sx
      )}
    >
      Test
    </LabelChip>
  </Tooltip>
);
